<template>
  <div class="phases">
    <div class="level table-actions">
      <div class="level-left">
        <form @submit.prevent="onSearch">
          <div class="field is-grouped controls">
            <div class="control">
              <b-input v-model="q" placeholder="Поиск..."></b-input>
            </div>
            <div class="control">
              <button type="submit" class="button is-primary">                   <b-icon icon="magnify" size="is-small"></b-icon>                 </button>
            </div>
          </div>
        </form>
      </div>
      <div class="level-right">
        <div class="field is-grouped controls">
          <div class="control">
            <button @click="goTo('createPhase')"
                    class="button is-success">
              Создать новую фазу
            </button>
          </div>
          <div class="control">
            <button @click="removeSelected"
                    :disabled="checkedRows.length === 0"
                    class="button is-danger">
              Удалить выделенные
            </button>
          </div>
        </div>
      </div>
    </div>
    <b-table class="mt-10"
             :data="list"
             :loading="loading"

             paginated
             backend-pagination
             :total="total"
             :per-page="perPage"
             @page-change="onPageChange"

             backend-sorting
             default-sort-direction="desc"
             :default-sort="[sortField, sortOrder]"
             @sort="onSort"

             checkable
             :checked-rows.sync="checkedRows"

             detailed
             detail-key="id">
      <template slot-scope="props">
        <b-table-column label="№" field="order_num" sortable>
          {{ props.row.order_num }}
        </b-table-column>
        <b-table-column label="Наименование" field="name" sortable>
          {{ props.row.name }}
        </b-table-column>
        <b-table-column label="Дата начала" field="start_date" width="140" sortable>
          {{ props.row.start_date | localedDateWithYear }}
        </b-table-column>
        <b-table-column label="Плановая дата завершения" width="140" field="end_date" sortable>
          <template v-if="props.row.end_date">{{ props.row.end_date | localedDateWithYear }}</template>
          <template v-else>&ndash;</template>
        </b-table-column>
        <b-table-column label="Фактическая дата завершения" width="150" field="completed_date" sortable>
          <template v-if="props.row.completed_date">{{ props.row.completed_date | localedDateWithYear }}</template>
          <template v-else>&ndash;</template>
        </b-table-column>
        <b-table-column label="Статус" width="120" field="is_completed" sortable>
          {{ props.row.is_completed ? 'Завершено' : 'В процессе' }}
        </b-table-column>
        <b-table-column width="150">
          <a @click="edit(props.row.id)">
            <b-icon icon="pencil" size="is-small" class="icon"></b-icon>
            Редактировать
          </a>
        </b-table-column>
      </template>

      <template slot="detail" slot-scope="props">
        <p>{{ props.row.description !== '' ? props.row.description : 'Описание фазы отсутсвует.' }}</p>
      </template>

      <template slot="empty">
        <section class="section">
          <div class="content is-fluid has-text-grey has-text-centered">
            <p>
              <span class="has-text-grey-light">Ничего не найдено, попробуйте </span>
              <a @click.prevent="resetFilters">сбросить фильтры и поиск</a>.
            </p>
          </div>
        </section>
      </template>
    </b-table>
  </div>
</template>

<script>
  import {mapState} from 'vuex'

  export default {
    data() {
      return {
        total: 0,
        page: 1,
        perPage: 15,
        q: '',
        sortField: '',
        sortOrder: 'desc',
        checkedRows: []
      }
    },
    methods: {
      loadData() {
        this.checkedRows = []
        this.$store.dispatch('Phase/getList', {
          params: {
            page: this.page,
            page_size: this.perPage,
            q: this.q,
            ordering: `${this.sortOrder === 'desc' ? '-' : ''}${this.sortField}`
          },
          projectId: this.$route.params.projectId
        }).then(data => {
          this.total = data.count
        })
      },
      onSort(field, order) {
        this.sortField = field
        this.sortOrder = order
        this.loadData()
      },
      onPageChange(page) {
        this.page = page
        this.loadData()
      },
      onSearch() {
        this.loadData()
      },
      resetFilters() {
        this.q = ''
        this.loadData()
      },
      goTo(route) {
        this.$router.push({name: route})
      },
      edit(id) {
        this.$router.push({
          name: 'editPhase',
          params: {projectId: this.$route.params.projectId, phaseId: id}
        })
      },
      removeSelected() {
        this.$dialog.confirm({
          title: this.$t('interface.dataDeleting'),
          message: this.$t('interface.dataDeletingMessage'),
          confirmText: this.$t('interface.dataDeleting'),
          cancelText: this.$t('interface.cancel'),
          type: 'is-danger',
          onConfirm: () => {
            this.checkedRows.map(row => {
              this.$store.dispatch('Phase/remove', {
                projectId: this.$route.params.projectId,
                phaseId: row.id
              }).then(() => this.loadData())
            })
          }
        })
      }
    },
    mounted() {
      this.loadData()
    },
    computed: {
      ...mapState('Phase', ['list', 'loading'])
    }
  }
</script>